(function () {
  'use strict';

  var KEYWORDS = ['use code', 'custom'];

  function mark() {
    var items = document.querySelectorAll(
      '[data-product-badge] .t4s-badge-custom, .t4s-single-product-badge .t4s-badge-custom',
    );
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      var text = (el.textContent || '').toLowerCase();
      var ok = false;
      for (var k = 0; k < KEYWORDS.length; k++) {
        if (text.indexOf(KEYWORDS[k]) !== -1) {
          ok = true;
          break;
        }
      }
      el.classList.toggle('mc-badge--card-ok', ok);

      el.classList.toggle('mc-badge--copy', /code[:\s]+[a-z0-9]/i.test(text));
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      mark();
    });
  }

  function boot() {
    mark();

    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (
            (n.matches &&
              (n.matches('.t4s-badge-item') ||
                n.matches('[data-product-badge]') ||
                n.matches('.t4s-product'))) ||
            (n.querySelector && n.querySelector('[data-product-badge], .t4s-badge-item'))
          ) {
            schedule();
            return;
          }
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });

    setTimeout(mark, 300);
    setTimeout(mark, 900);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

(function () {
  'use strict';

  function extractCode(text) {
    var m = (text || '').match(/code[:\s]+([A-Za-z0-9][A-Za-z0-9\-]*)/i);
    return m ? m[1] : null;
  }

  function copy(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }

  function flash(badge) {
    if (badge._mcCopyTimer) clearTimeout(badge._mcCopyTimer);
    badge.classList.add('is--mc-copied');
    badge._mcCopyTimer = setTimeout(function () {
      badge.classList.remove('is--mc-copied');
    }, 1500);
  }

  document.addEventListener(
    'click',
    function (e) {
      var badge = e.target.closest && e.target.closest('.t4s-badge-custom.mc-badge--copy');
      if (!badge) return;
      var code = extractCode(badge.textContent);
      if (!code) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      flash(badge);
      copy(code).catch(function () {});
    },
    true,
  );
})();
